import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { VueAutosuggest } from 'vue-autosuggest';
import VueDropzone from 'vue2-dropzone';
import InputTag from "../../../../components/Form/InputTag";
import Switches from 'vue-switches';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import Stars from "../../../../components/Common/Stars";
import { setTimeout } from 'timers';
import { getDirection } from "../../../../utils";
export default {
  components: {
    'v-select': vSelect,
    'vue-autosuggest': VueAutosuggest,
    'vue-dropzone': VueDropzone,
    'input-tag': InputTag,
    'switches': Switches,
    'vue-slider': VueSlider,
    'stars': Stars
  },
  data: function data() {
    return {
      rate: 3,
      disabledRate: 4,
      sliderValue: 65,
      sliderDoubleValue: [100, 400],
      sliderData: [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
      selectedValueSingle: new Date(),
      selectedValueDisabled: new Date(),
      selectedValueSingleInline: new Date(),
      selectedValueRange: {
        start: new Date(2018, 12, 9),
        end: new Date(2018, 12, 18)
      },
      vueSelectForm: {
        single: '',
        multiple: []
      },
      vueSelectOptions: [],
      direction: getDirection().direction,
      selectData: ['Chocolate', 'Vanilla', 'Strawberry', 'Caramel', 'Cookies and Cream', 'Peppermint'],
      vueAutosuggestForm: {
        selected: {}
      },
      filteredOptions: [],
      suggestions: [{
        data: [{
          id: 1,
          name: 'Marble Cake'
        }, {
          id: 2,
          name: 'Fruitcake'
        }, {
          id: 3,
          name: 'Chocolate Cake'
        }, {
          id: 4,
          name: 'Fat Rascal'
        }, {
          id: 5,
          name: 'Financier'
        }, {
          id: 6,
          name: 'Genoise'
        }, {
          id: 7,
          name: 'Gingerbread'
        }, {
          id: 8,
          name: 'Goose Breast'
        }, {
          id: 9,
          name: 'Parkin'
        }, {
          id: 10,
          name: 'Petit Gâteau'
        }, {
          id: 11,
          name: 'Salzburger Nockerl'
        }, {
          id: 12,
          name: 'Soufflé'
        }, {
          id: 13,
          name: 'Streuselkuchen'
        }, {
          id: 14,
          name: 'Tea Loaf'
        }, {
          id: 15,
          name: 'Napoleonshat'
        }, {
          id: 16,
          name: 'Merveilleux'
        }, {
          id: 17,
          name: 'Magdalena'
        }, {
          id: 18,
          name: 'Cremeschnitte'
        }, {
          id: 19,
          name: 'Cheesecake'
        }, {
          id: 20,
          name: 'Bebinca'
        }]
      }],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailHeight: 160,
        maxFilesize: 2,
        previewTemplate: this.dropzoneTemplate(),
        headers: {
          'My-Awesome-Header': 'header value'
        }
      },
      tags: [],
      switches: {
        primary: true,
        secondary: false,
        primaryInverse: false,
        secondaryInverse: true
      }
    };
  },
  mounted: function mounted() {
    var that = this;
    setTimeout(function () {
      that.$refs.slider.refresh();
      that.$refs.sliderSingle.refresh();
    }, 500);
  },
  methods: {
    onAutoSuggestInputChange: function onAutoSuggestInputChange(text, oldText) {
      if (text === null) {
        /* Maybe the text is null but you wanna do
         *  something else, but don't filter by null.
         */
        return;
      }

      var filteredData = this.suggestions[0].data.filter(function (option) {
        return option.name.toLowerCase().indexOf(text.toLowerCase()) > -1;
      }); // Store data in one property, and filtered in another

      this.filteredOptions = [{
        data: filteredData
      }];
    },
    onAutosuggestSelected: function onAutosuggestSelected(item) {
      this.vueAutosuggestForm.selected = item;
    },
    renderSuggestion: function renderSuggestion(suggestion) {
      var character = suggestion.item;
      return character.name;
      /* renderSuggestion will override the default suggestion template slot. */
    },
    getSuggestionValue: function getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
    dropzoneTemplate: function dropzoneTemplate() {
      return "<div class=\"dz-preview dz-file-preview mb-3\">\n                  <div class=\"d-flex flex-row \"> <div class=\"p-0 w-30 position-relative\">\n                      <div class=\"dz-error-mark\"><span><i></i>  </span></div>\n                      <div class=\"dz-success-mark\"><span><i></i></span></div>\n                      <div class=\"preview-container\">\n                        <img data-dz-thumbnail class=\"img-thumbnail border-0\" />\n                        <i class=\"simple-icon-doc preview-icon\"></i>\n                      </div>\n                  </div>\n                  <div class=\"pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative\">\n                    <div> <span data-dz-name /> </div>\n                    <div class=\"text-primary text-extra-small\" data-dz-size /> </div>\n                    <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n                    <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n                  </div>\n                  <a href=\"#\" class=\"remove\" data-dz-remove> <i class=\"glyph-icon simple-icon-trash\"></i> </a>\n                </div>\n        ";
    },
    fetchOptions: function fetchOptions(search, loading) {
      var _this = this;

      loading(true);
      setTimeout(function () {
        fetch("https://api.github.com/search/repositories?q=".concat(escape(search))).then(function (res) {
          res.json().then(function (json) {
            return _this.vueSelectOptions = json.items;
          });
          loading(false);
        });
      }, 1000);
    }
  }
};